import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'

export const DownloadButton = () => {
  return (
    <Button
      icon={<DownloadOutlined />}
      style={{ paddingInline: 4 }}
      type='text'
    >
      下载
    </Button>
  )
}
